// Firebase configuration and initialization

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

// Replace with your Firebase Console config
const firebaseConfig = {
  apiKey: "AIzaSyAW47Mptc3r011toii2i1NJSPAJGlVSlEs",
  authDomain: "dcs-workbook-294ab.firebaseapp.com",
  projectId: "dcs-workbook-294ab",
  storageBucket: "dcs-workbook-294ab.firebasestorage.app",
  messagingSenderId: "797714849687",
  appId: "1:797714849687:web:efad84b9b2c9b5fa49aed2"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const firestore = getFirestore(app);
export const functions = getFunctions(app);
